module.exports = __webpack_public_path__ + "static/media/bg_whats-on-back.942a00f9.jpg";